import { put, takeEvery } from 'redux-saga/effects';
import {
  fetchRolesSuccess,
  fetchRolesFailure,
  fetchSingleRoleSuccess,
  fetchSingleRoleFailure,
} from 'redux/ums-user-management/actions';
import request from 'utils/request';
import urls from 'utils/config';
import UmsUserManagementActionTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';


const { API_BASE_URL } = urls || {};

export function* fetchRoles() {
  const url = `${API_BASE_URL}/ums/roles`;

  const response = yield request({
    method: 'get',
    url,
  });

  if (response.success) {
    yield put(fetchRolesSuccess(response.raw));
  } else {
    networkErrorHandler(response?.statusCode, `Failed to Fetch Roles: ${response.message}`);

    yield put(fetchRolesFailure(response.message));
  }
}

export function* onFetchRoles() {
  yield takeEvery(
    UmsUserManagementActionTypes.FETCH_UMS_ROLES_START,
    fetchRoles
  );
}

export function* fetchSingleRole({ payload: { id, cb } }) {
  const url = `${API_BASE_URL}/ums/roles/${id}`;

  const response = yield request({
    method: 'get',
    url,
  });

  if (response.success) {
    yield put(fetchSingleRoleSuccess(response.raw));
  } else {
    networkErrorHandler(response?.statusCode, `Failed to Fetch Role: ${response.message}`);
    yield put(fetchSingleRoleFailure(response.message));
    cb();
  }
}

export function* onFetchSingleRole() {
  yield takeEvery(
    UmsUserManagementActionTypes.FETCH_UMS_SINGLE_ROLE_START,
    fetchSingleRole
  );
}
